import { useEffect, useState } from "react";
import "./App.css";
import { Report } from "./components";
import IdleTimer from "./utils/IdleTimer";
import { getCookie } from "./utils/cookies";


function App() {
  const [tracking, setTracking] = useState(false);

  useEffect(() => {
    if (getCookie("verifierid")) {
      new IdleTimer();
      setTracking(true);
    } else if (process.env.NODE_ENV === "development") {
      // Dev-only preview: show the indicator even without a verifier cookie
      // so the layout can be inspected locally. Does NOT start tracking.
      setTracking(true);
    }
  }, []);

  return (
    <div>
      <Report />
      {tracking && (
        <div
          title="Activity tracking active"
          style={{
            position: "fixed",
            bottom: 12,
            left: 12,
            width: 14,
            height: 14,
            borderRadius: 3,
            background: "#22c55e",
            boxShadow: "0 0 0 2px rgba(255,255,255,0.6), 0 1px 3px rgba(0,0,0,0.2)",
            zIndex: 9999,
          }}
        />
      )}
    </div>
  );
}

export default App;
